import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';

@Component({
  selector: 'app-campaign-3-search-department',
  templateUrl: './campaign-3-search-department.component.html',
  styleUrls: ['./campaign-3-search-department.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchDepartmentComponent implements OnInit {
  
  @Input() departmentList: Array<any> = [];
  @Output() departmentListSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() departmentListCancel: EventEmitter<boolean> = new EventEmitter<boolean>();

  listDepartmentSelected: Array<any> = [];
  paginationType: number = Campaign3KontableComponent.NoPagination;
  
  show = {
    table: false
  }
  
  constructor() {}
  ngOnInit() {
    if(this.departmentList){

      for(let pan of this.departmentList){
        if(pan.rowSelected == true){
          this.listDepartmentSelected.push(Object.assign({},pan));
        }
      }
      this.show.table = true;
    }
  }
  onDepartmentSelected(pan: any){
   
    let indexInSelected = this.listDepartmentSelected.findIndex(x=>x.id == pan.id);
    if(!pan.rowSelected){
      if(indexInSelected>-1) this.listDepartmentSelected.splice(indexInSelected,1);
    }
    else if(pan.rowSelected){
      if(indexInSelected==-1) this.listDepartmentSelected.push(pan);
    }
  }
  onClickAggiungiDepartment(){
 
    if(this.listDepartmentSelected && this.listDepartmentSelected.length){
      this.departmentListSelected.emit(this.listDepartmentSelected);
    }
    else{
      this.departmentListSelected.emit(null);
    }
  }
  onClickAnnullaDepartment(){
    this.departmentListCancel.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-department/campaign-3-search-department.component.ts